import React from "../../../__snowpack__/pkg/react.js";
export const copyIcon = () => /* @__PURE__ */ React.createElement("svg", {
  width: "14px",
  height: "16px",
  viewBox: "0 0 12 12",
  version: "1.1",
  fill: "currentColor"
}, /* @__PURE__ */ React.createElement("title", null), /* @__PURE__ */ React.createElement("g", {
  id: "copy-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("g", {
  id: "copy-hover",
  transform: "translate(-441.000000, -620.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /* @__PURE__ */ React.createElement("g", {
  id: "copy-10",
  transform: "translate(441.000000, 620.000000)"
}, /* @__PURE__ */ React.createElement("path", {
  d: "M8.25,3 C8.66370602,3.00122275 8.99877725,3.33629398 9,3.75 L9,3.75 L9,9.75 C8.99877725,10.163706 8.66370602,10.4987772 8.25,10.5 L8.25,10.5 L2.25,10.5 C1.83629398,10.4987772 1.50122275,10.163706 1.5,9.75 L1.5,9.75 L1.5,3.75 C1.50122275,3.33629398 1.83629398,3.00122275 2.25,3 L2.25,3 Z M8.24871094,3.75 L2.25128906,3.75 L2.25,3.75128906 L2.25,9.74871094 L2.25128906,9.75 L8.24871094,9.75 L8.25,9.74871094 L8.25,3.75128906 L8.24871094,3.75 Z M9.75,1.5 C10.163706,1.50122275 10.4987772,1.83629398 10.5,2.25 L10.5,2.25 L10.5,8.25 C10.4987772,8.66370602 10.163706,8.99877725 9.75,9 L9.75,9 L9.375,9 L9.375,8.25 L9.74871094,8.25 L9.75,8.24871094 L9.75,2.25128906 L9.74871094,2.25 L3.75128906,2.25 L3.75,2.25128906 L3.75,2.625 L3,2.625 L3,2.25 C3.00122275,1.83629398 3.33629398,1.50122275 3.75,1.5 L3.75,1.5 Z M7.5,7.5 L7.5,8.25 L3,8.25 L3,7.5 L7.5,7.5 Z M7.5,5.25 L7.5,6 L3,6 L3,5.25 L7.5,5.25 Z",
  id: "copy"
})))));
